module.exports = __webpack_public_path__ + "img/logo-MATIC.9729dabc.svg";